import { useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom/client";

import "./index.scss";
import SideBar from "../src/platform/components/side-bar/side-bar";
import { createSideBarConfig } from "../src/platform/composers/side-bar-composer";
import App from "./app";
import { CustomBrowserRouter } from "./custom-browser-router";
import Spinner from "./shared/components/spinner/spinner";
import { baseUrl } from "./shared/constants/backend-constants";
import { AuthContextProvider } from "./shared/context/auth-context";
import AuthContext from "./shared/context/auth-context";
import { Backend } from "./shared/utils/backend";
import { Dependencies } from "./shared/utils/dependencies";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

function IndexWrapper() {
  const [configLoaded, setConfigLoaded] = useState(false);
  const authCtx = useContext(AuthContext);

  useEffect(() => {
    let retries = 0;
    const maxRetries = 50;
    const checkConfig = () => {
      if (window.__APP_CONFIG__) {
        new Dependencies(new Backend(baseUrl));
        setConfigLoaded(true);
      } else if (retries < maxRetries) {
        retries++;
        setTimeout(checkConfig, 100);
      } else {
        console.error("Failed to load app config within the allowed time.");
      }
    };

    checkConfig();
  }, []);

  // Show loading screen while config is being loaded
  if (!configLoaded) {
    return (
      <Spinner  />
    );
  }

  return (
    <div className="platformLayout">
      <div className="platformLayout-sideBar">
        {authCtx.isLoggedIn ? <SideBar {...createSideBarConfig(authCtx.selectedTenant.roles, authCtx.systemAdmin, authCtx.onboardingAnalyticsData, authCtx.onboardingPlatformData, authCtx.onboardingManagerData)} /> : ""}
      </div>
      <CustomBrowserRouter>
        <App />
      </CustomBrowserRouter>
    </div>
  );
}
root.render(
  <AuthContextProvider>
    <IndexWrapper />
  </AuthContextProvider>
);
